import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { actions, selectors, type PreferencesState } from "../slices/preferencesSlice";

export const usePreferences = () => {
  const dispatch = useAppDispatch();
  const preferences = useAppSelector(selectors.getPreferences);

  const updatePreferences = useCallback(
    (newPreferences: Partial<PreferencesState>) => {
      dispatch(actions.updatePreferences(newPreferences));
    },
    [dispatch],
  );

  return [preferences, updatePreferences] as const;
};
